module.exports = __webpack_public_path__ + "static/media/CORDEL-MROSC-CAPA.b32c40ca.jpg";